import { Selector, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromState from './command-content.state';
import * as fromReducer from './command-content.reducer';

import { MdmCommand } from '@rocksoft/mdm-sdk-v2';

export const selectCommandContentState: Selector<object, fromState.CommandContentState> =
  createFeatureSelector<fromState.CommandContentState>(fromReducer.commandContentFeatureKey);

export const selectCommandContentById = (commandUUID: string) =>
  createSelector(selectAllCommandContent, (contents: MdmCommand[]) =>
    contents.find((c) => c.commandUUID === commandUUID)
  );

export const selectAllCommandContent = createSelector(selectCommandContentState, fromReducer.selectAllCommandContent);

export const selectCommandContentEntities = createSelector(
  selectCommandContentState,
  fromReducer.selectCommandContentEntities
);

export const selectCommandContentIds = createSelector(selectCommandContentState, fromReducer.selectCommandContentIds);
